export const api_key = "CNCPLAaS4rpLQvcEltE2";
export const sdkWrapperURL = (url = "") =>
  new URL(url, "https://api-dev-sdk-wrapper-app.carenow.healthcare");
export const sdkURL = (url = "") => new URL(url, "https://sdk-dev.carenow.healthcare");
